import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    signal,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmsService,
    LanguageService,
    ProductService,
    RoutingService,
} from '@spartacus/core';
import { distinctUntilChanged, filter, Subscription, tap } from 'rxjs';
import { CheckoutService } from 'src/app/shared/modules/checkout/checkout.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { CustomB2BUnit } from '../../../shared/models/user.model';
import { AccountOverviewService } from '../../account-overview.service';

@Component({
    selector: 'app-acc-overview-placeholder1',
    templateUrl: './acc-overview-placeholder1.component.html',
    styleUrls: ['./acc-overview-placeholder1.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccOverviewPlaceholder1Component implements OnInit, OnDestroy {
  accountNumber: string = null;
  compNameAdBanner = 'SanofiAccountOverviewBannerComponent4';
  compNameAdBanner2 = 'SanofiAccountOverviewBannerComponent2';
  compNameAdBanner3 = 'SanofiAccountOverviewBannerComponent3';
  compNameAdBanner6 = 'SanofiAccountOverviewBannerComponent6';
  compNameAdBanner1 = 'SanofiAccountOverviewBannerComponent';
  cmsResponse: any;
  productCodes: any;
  prodcutsInfo: any = [];
  prodDocs: any = [];
  prodDocus: any = [];
  fluResevartion: boolean;
  private subscriptions = new Subscription();
  accountData = signal<CustomB2BUnit | null>(null);

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly cmsData: CmsService,
    protected productService: ProductService,
    private readonly checkoutService: CheckoutService,
    private readonly sanitizer: DomSanitizer,
    private readonly lang: LanguageService,
    protected locationStripService: LoactionStripService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.lang.getActive().subscribe((res) => {
        if (res) {
          this.prodcutsInfo = [];
        }
        this.cdr.detectChanges();
      })
    );
    this.subscriptions.add(
      this.locationStripService.userAccountData
        .pipe(
          filter(Boolean),
          distinctUntilChanged((prev, curr) => prev.uid === curr.uid),
          tap(() => this.accountData.set(null))
        )
        .subscribe((res) => {
          this.accountData.set(res);
      })
    );

    this.subscriptions.add(
      this.cmsData
        .getComponentData('ProductMonographComponent')
        .subscribe((res) => {
          this.cmsResponse = res;
          this.cdr.detectChanges();
        })
    );

    this.productMonograph();
  }

  navigateToAccountDetails() {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Account information');
  }
  productMonograph() {
    this.productCodes = this.cmsResponse?.productCodes;
    this.productCodes = this.productCodes?.split(' ');
    this.productCodes?.forEach((element) => {
      this.subscriptions.add(
        this.productService.get(element).subscribe((res) => {
          if (res) {
            this.prodcutsInfo.push(res);
            this.cdr.detectChanges();
          }
        })
      );
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
